// Bumped whenever any of the wording below changes. The version travels with the
// approval and with the decline, and the server records it, because a consent record
// that says only "approved" proves nothing once the text it refers to has been rewritten.
// The server holds the same literal in
// server/src/api/contact/common/contact-consent-event.ts; bump both together.
export const LIABILITY_STATEMENT_WORDING_VERSION = 'liability-statement-2026-09'

export const LIABILITY_STATEMENT_TITLE = 'אישור הצהרת אחריות'

export const LIABILITY_STATEMENT_PARAGRAPHS = [
    'סימון הפרט לאישור מהווה הצהרה שהנמען נתן את הסכמתו לקבל מכם מייל שיווקי.',
    'האחריות להצהרה הזו היא של המשרד בלבד, ולא של המערכת.',
]

export const LIABILITY_STATEMENT_APPROVE_LABEL = 'אני מאשר/ת'

export const LIABILITY_STATEMENT_DECLINE_LABEL = 'ביטול'
